import Dealer from '@/api/administrator/dealer-profile'
import transaction from '@/api/report/dealer-transaction'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  preview(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      attrubutes
    )

    return transaction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return transaction.store(data)
  },
  fetchDealer(context) {
    return Dealer.get({
      params: {
        fields: {
          dealer_profiles:
            'dealer_id,dealer_name,topup_commission_rate,main_balance'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
